export default __webpack_public_path__ + "static/media/Forbes.041e9995.jpg";